<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader :color="'#af7c00'" :size="'2em'" :loading="loading">
      </pulse-loader>
    </div>

    <div class="content" v-if="!loading">
      <div class="title__container" v-if="!isRated">
        <p class="title__text">
          {{ this.$store.getters.TRANSLATIONS["how_did_we_do"] }}
        </p>
      </div>
      <div class="rating" v-if="!isRated">
        <p class="rating__title">
          {{ this.$store.getters.TRANSLATIONS["rate_your_experience"] }}
        </p>
        <div class="star-rating">
          <star-rating
            @rating-selected="setRating"
            v-model="rating"
            :show-rating="false"
            :padding="9"
            :inline="true"
            :star-size="starSize"
            :animate="true"
            active-color="#FBAE31"
          ></star-rating>
        </div>

        <button v-on:click="sendRating()" class="button button__send">
          {{ this.$store.getters.TRANSLATIONS["continue"] }}
        </button>
      </div>

      <div class="gratitude" v-if="isRated">
        <p class="gratitude__title">
          {{ this.$store.getters.TRANSLATIONS["thank_you_for"] }}
        </p>
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <div class="footer__content">
        <p class="footer__text">
          {{ this.$store.getters.TRANSLATIONS["powered_by"] }}
          <span class="footer__text--underlined">parkenda</span>
        </p>
        <img
          class="footer__img"
          src="../../assets/new_design/PRKPRO_VerticalLogo_White 1.png"
          alt="PRKPRO_VerticalLogo_White"
        />
      </div>
    </div>
    <modal
      name="detailsModal"
      styles="border-radius: 30px; border: 1px solid #FBAE31; padding: 0 7%;"
      width="72.46%"
      height="57.14%"
      :pivotY="0.5"
      :clickToClose="false"
    >
      <p class="modal__title">
        {{ this.$store.getters.TRANSLATIONS["would_you_like_provide"] }}
      </p>
      <textarea
        v-model="details"
        class="modal__textarea"
        :placeholder="this.$store.getters.TRANSLATIONS['enter_message']"
      >
      </textarea>

      <button
        v-on:click="$modal.hide('detailsModal'), sendRating()"
        class="modal__button1"
      >
        {{ this.$store.getters.TRANSLATIONS["continue"] }}
      </button>
      <button v-on:click="$modal.hide('detailsModal')" class="modal__button2">
        {{ this.$store.getters.TRANSLATIONS["no_thank_you"] }}
      </button>
    </modal>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";

export default {
  data() {
    this.starSize = (window.innerWidth * 35) / 414;
    this.details = "";
    this.ticketBarcode = this.$route.query.ticketBarcode;
    this.isRated = false;
    return {
      starSize: (window.innerWidth * 35) / 414,
      notification: this.$store.getters.TRANSLATIONS["no_thank_you"],
      rating: 5,
      loading: false,
      isRated: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058_1.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      sendRating: () => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(`${process.env.SERVER_URL}/2210F70E1B5E46BE92FF99BB9273C679`, {
            value: this.rating,
            type: "SMS",
            ticketBarcode: this.ticketBarcode,
            details: this.details
          })
          .then((response) => {
            console.log(response);
            this.$modal.hide("detailsModal");

            this.isRated = true;
          })
          .catch((error) => {
            let text =
              this.$store.getters.TRANSLATIONS["rating_request_failed"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              text = error.response.data.message;
            }
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      }
    };
  },
  components: {
    StarRating
  },
  methods: {
    setRating(rating) {
      this.rating = rating;
      this.rating < 4
        ? (this.$modal.hide("ratingModal"), this.$modal.show("detailsModal"))
        : null;
    }
  },
  mounted() {
    if (!this.$store.getters.TRANSLATIONS) {
      location.reload();
    }
    window.onresize = () => {
      this.starSize = (window.innerWidth * 35) / 414;
    };
  }
};
</script>

<style scoped src="../../styles/webrequest.main.css"></style>
<style scoped>
.rating__title {
  margin: 15vh auto 5vh auto;
  text-align: center;
  font-weight: normal;
  font-size: 1.34vh;
  line-height: 1.9vh;
  color: #fff;
}

.button {
  background-color: #fbae31;
  border: none;
  color: #fff;
  text-align: center;
  text-decoration: none;
  display: block;
  font-size: 2vh;
  margin: 3vh auto 3vh auto;
  height: 5.5vh;
  width: 50%;
  text-decoration: none;
  border-radius: 100px;
  overflow: hidden;
  cursor: pointer;
  outline: none;
}

.button__send {
  margin: 6vh auto 0 auto;
  width: 40%;
}
.button__thanks {
  background-color: #000;
  color: #fff;
  margin: 2vh auto 0 auto;
}
.modal__title {
  text-align: center;
  margin: 5.58vh 4.84vw 3.91vh 4.84vw;
  font-weight: normal;
  font-size: 1.78vh;
  line-height: 2.57vh;
}
.gratitude__title {
  margin: 30vh auto;
  font-weight: 700;
  font-size: 3vh;
  color: #fbae31;
  width: 60vw;
}
</style>



// WEBPACK FOOTER //
// src/components/WebRequest/HowAreWeDoingSoFar.vue